/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';
import { GptPredictionDecision } from 'src/clu/core/services/gpt/cluGptSwagger';
import { CluUtteranceStore } from 'src/clu/core/stores/CluUtteranceStore';
import { OmitFunctions } from 'src/core/stores/types';

type CluGptPredictedUtteranceStoreData = OmitFunctions<
    Omit<Partial<CluGptPredictedUtteranceStore>, 'id' | 'generationDecision' | 'predictionDecision'>
>;

export class CluGptPredictedUtteranceStore extends CluUtteranceStore {
    @observable public updatedText?: string;

    @observable public updatedLabeledIntentName?: string;

    @observable public generationDecision: GptPredictionDecision;

    @observable public predictionDecision: GptPredictionDecision;

    constructor(data: CluGptPredictedUtteranceStoreData) {
        super(data);

        this.updatedText = data.updatedText;
        this.updatedLabeledIntentName = data.updatedLabeledIntentName;
    }

    @action
    public setUpdatedText(updatedText: string) {
        this.updatedText = updatedText;
        this.tokenizedText = updatedText.split('');
    }

    @action
    public setUpdatedLabeledIntentName(intentName: string) {
        this.updatedLabeledIntentName = intentName;
    }

    @action
    public setGenerationDecision(generationDecision: GptPredictionDecision) {
        this.generationDecision = generationDecision;
    }

    @action
    public setPredictionDecision(predictionDecision: GptPredictionDecision) {
        this.predictionDecision = predictionDecision;
    }
}
